import { MDX } from "./mdx/tokens";

/**
 * CurrencyToggle — Interactive pill supporting KES · USD · EUR.
 * Emits the selected code via `onChange`. Uses brand-red for the active state
 * so it matches the pricing card border and the metric-tab pill.
 */
export default function CurrencyToggle({ value, onChange, isDark, testid = "currency-toggle" }) {
    const dim = isDark ? "text-[#9CA3AF]" : "text-[#6B7280]";
    const brd = isDark ? "border-[#1F2937]" : "border-[#E5E7EB]";
    const bg  = isDark ? "bg-[#0F1524]" : "bg-white";

    const opts = ["KES", "USD", "EUR"];
    return (
        <div
            data-testid={testid}
            className={`inline-flex items-center gap-1 p-1 rounded-full border ${brd} ${bg}`}
        >
            <span className={`px-2 font-inter text-[11px] uppercase tracking-wider font-semibold ${dim}`}>
                Show in
            </span>
            {opts.map((c) => {
                const active = value === c;
                return (
                    <button
                        key={c}
                        type="button"
                        onClick={() => onChange?.(c)}
                        data-testid={`${testid}-${c.toLowerCase()}`}
                        aria-pressed={active}
                        className="font-inter font-bold text-[12px] uppercase tracking-wider rounded-full px-3 py-1 transition-colors"
                        style={
                            active
                                ? { background: MDX.blueLowSolid, color: "#fff" }
                                : { background: "transparent", color: isDark ? "#9CA3AF" : "#6B7280" }
                        }
                    >
                        {c}
                    </button>
                );
            })}
        </div>
    );
}
